import { Box } from '@mui/material'

export const SpaceBox = (): React.JSX.Element => <Box sx={{ flexGrow: 1 }} />
